import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import PostCard from '../components/PostCard';
import CommentDrawer from '../components/CommentDrawer';
import api from '../lib/api';
import { Bookmark } from 'lucide-react';
import { motion } from 'framer-motion';

export const Saved = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeComment, setActiveComment] = useState(null);

  useEffect(() => {
    api.get('/posts/saved').then(r => { setPosts(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  return (
    <Layout>
      <motion.div
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="mb-8 flex items-center gap-4"
      >
        <div className="w-14 h-14 rounded-2xl bg-[#FFB000]/10 border border-[#FFB000]/20 flex items-center justify-center">
          <Bookmark size={24} className="text-[#FFB000]" fill="#FFB000" />
        </div>
        <div>
          <div className="text-xs tracking-[0.2em] uppercase font-bold text-[#FFB000]">Your library</div>
          <h1 className="font-heading font-black text-white text-4xl md:text-5xl tracking-tighter">
            Saved Music
          </h1>
        </div>
      </motion.div>

      {loading ? (
        <div className="post-card h-96 animate-pulse" />
      ) : posts.length === 0 ? (
        <div className="post-card p-12 text-center">
          <Bookmark size={36} className="text-[#A1A1AA] mx-auto mb-3" />
          <h3 className="font-heading font-bold text-xl text-white mb-2">Nothing saved yet</h3>
          <p className="text-[#A1A1AA]">Tap the bookmark on any mix to save it here for later.</p>
        </div>
      ) : (
        <div className="space-y-6">
          {posts.map(p => <PostCard key={p.id} post={p} onCommentOpen={setActiveComment} />)}
        </div>
      )}
      <CommentDrawer post={activeComment} onClose={() => setActiveComment(null)} />
    </Layout>
  );
};

export default Saved;
